// @ai-generated 2026-08-21T00:00:00Z by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)

export interface WorkflowTool {
    /** `WorkflowToolNaming.ToolNamePrefix` plus the definition key. */
    name: string;
    /** The definition's Label, which the tool result does not carry. */
    title: string;
}

/**
 * Only seeded workflows get a card: their names are fixed at build time, unlike the definitions
 * users add themselves, which are named after whatever key they chose.
 */
export const WORKFLOW_TOOLS: WorkflowTool[] = [{ name: 'wf_monthly_faktura', title: 'Monatliche Faktura' }];

/**
 * Key of the seeded Faktura workflow, mirroring `AgenticOrchestratorInitializer`'s
 * `MonthlyFakturaDefinitionKey`. The key rather than the id: the definition is a seeded row, and its
 * id is data no frontend should carry.
 */
export const MONTHLY_FAKTURA_KEY = 'monthly_faktura';

export function workflowTitleOf(definitionKey: string): string {
    return WORKFLOW_TOOLS.find((tool) => tool.name === definitionKey)?.title ?? definitionKey;
}
